export default __webpack_public_path__ + "static/media/home-img.e2dfb1ca.jpg";